import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { getTrackPathPrefix } from '@src/components/sco/Education/ContentTrackContext';
import { ContentTrackSectionDashboard } from '@src/components/sco/Education/ContentTrackSectionDetail/ContentTrackSectionDashboard';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { EducationErrorState } from '@src/components/sco/Education/EducationErrorState';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import React from 'react';
type ContentTracksSectionDetailProps = {
  contentTrackSlug: string;
  contentTrackSectionSlug: string;
};
export const ContentTrackSectionDetail = (props: ContentTracksSectionDetailProps) => {
  const educationContext = useEducationContext();
  const query = useQuery(gql`
    query ($contentTrackSlug: String, $contentTrackSectionSlug: String) {
      contentTrackSections(
        where: { parentContentTrack: { slug: $contentTrackSlug }, slug: $contentTrackSectionSlug }
        first: 1
      ) {
        id
        parentContentTrack {
          id
          title
          slug
          type
        }
        ${ContentTrackSectionDashboard.fragments.ContentTrackSection()}
      }
    }
  `, {
    variables: {
      contentTrackSlug: props.contentTrackSlug,
      contentTrackSectionSlug: props.contentTrackSectionSlug
    }
  });
  const contentTrackSection = query.data?.contentTrackSections[0];
  const contentTrack = contentTrackSection?.parentContentTrack;
  useUniversalEffect(() => {
    educationContext.setBreadcrumbs([{
      title: 'Courses',
      href: '/courses'
    }, {
      title: contentTrack?.title || '...',
      href: `/${getTrackPathPrefix(contentTrack)}/${contentTrack?.slug}`
    }, {
      title: contentTrackSection?.title || '...',
      href: `/${getTrackPathPrefix(contentTrack)}/${contentTrack?.slug}/${contentTrackSection?.slug}`
    }]);
  }, [contentTrackSection?.slug, contentTrackSection?.title, contentTrack?.slug, contentTrack?.title]);
  return <Box>
      {query.loading && <Center padding={10}>
          <Spinner />
        </Center>}
      {query.error && <Box>
          {'Error: '}
          {`${query.error?.toString()}`}
        </Box>}
      {!query.loading && !contentTrackSection && <EducationErrorState ctaHref={'/courses'} ctaLabel={'Explore All Courses'} headingText={'Course Section Not Found'} />}
      {contentTrackSection && <ContentTrackSectionDashboard contentTrackSection={contentTrackSection} />}
    </Box>;
};